import { ACtaBoxMixin } from '../utils/mixins/_a-cta-box';

class ACtaBoxButton extends ACtaBoxMixin(HTMLButtonElement) {}

customElements.define('a-cta-box-button', ACtaBoxButton, { extends: 'button' });
